export const RANKING_VALUE_TEST_ID = "ranking-value";
